/**
 * Mobile sticky "Build your bundle" control.
 * Jumps to size selection (so that step is visible above the bundle picker)
 * and hides while any part of the bundle section is on screen.
 */
(function () {
  var DESKTOP_MQ = '(min-width: 750px)';
  var BUNDLE_SELECTOR = '[data-bundle-anchor]';

  var intersectionObserver;
  var mutationObserver;
  var mediaQuery;
  var initTimer;

  function portalButton() {
    var inProduct = document.querySelector('product-info [data-sticky-build-bundle]');
    var onBody = Array.from(document.querySelectorAll('body > [data-sticky-build-bundle]'));

    if (inProduct) {
      onBody.forEach(function (el) {
        el.remove();
      });
      document.body.appendChild(inProduct);
      return inProduct;
    }

    if (!onBody.length) return null;

    var keep = onBody[onBody.length - 1];
    onBody.forEach(function (el) {
      if (el !== keep) el.remove();
    });

    var sectionId = keep.getAttribute('data-section-id');
    var productInfo = document.getElementById('MainProduct-' + sectionId);
    if (!productInfo || !productInfo.querySelector('[data-bundle-anchor]')) {
      keep.remove();
      return null;
    }

    return keep;
  }

  function productRoot(btn) {
    var sectionId = btn.getAttribute('data-section-id');
    return document.getElementById('MainProduct-' + sectionId) || document;
  }

  function findTarget(btn) {
    var root = productRoot(btn);
    var ownedBundle = root.querySelector('evertee-owned-bundle[data-bundle-anchor]');
    if (ownedBundle) return ownedBundle;
    var widget = root.querySelector(BUNDLE_SELECTOR);
    if (widget) return widget;
    return document.getElementById('BuildYourBundle-' + btn.getAttribute('data-section-id'));
  }

  function findScrollTarget(btn) {
    var root = productRoot(btn);
    var sizeStep =
      root.querySelector('.variant-picker-step--size') || root.querySelector('[data-size-option]');
    if (sizeStep) return sizeStep;
    return findTarget(btn);
  }

  function setVisible(btn, show) {
    if (!btn) {
      document.body.classList.remove('sticky-build-bundle-visible');
      return;
    }

    document.body.classList.toggle('sticky-build-bundle-visible', show);
    btn.classList.toggle('is-visible', show);
    btn.setAttribute('aria-hidden', show ? 'false' : 'true');
    if (show) {
      btn.removeAttribute('tabindex');
    } else {
      btn.tabIndex = -1;
    }
  }

  function bindObserver(btn) {
    if (intersectionObserver) {
      intersectionObserver.disconnect();
      intersectionObserver = undefined;
    }

    if (window.matchMedia(DESKTOP_MQ).matches) {
      setVisible(btn, false);
      return;
    }

    var target = findTarget(btn);
    if (!target) {
      setVisible(btn, false);
      return;
    }

    target.style.scrollMarginTop = '8rem';

    var bounds = target.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    setVisible(btn, !(bounds.top < viewportHeight && bounds.bottom > 0));

    intersectionObserver = new IntersectionObserver(
      function (entries) {
        if (!entries[0]) return;
        setVisible(btn, !entries[0].isIntersecting);
      },
      { threshold: 0, rootMargin: '0px' }
    );
    intersectionObserver.observe(target);
  }

  function observeProductInfo(btn) {
    var sectionId = btn.getAttribute('data-section-id');
    var productInfo = document.getElementById('MainProduct-' + sectionId);
    if (!productInfo) return;

    if (mutationObserver) {
      mutationObserver.disconnect();
      mutationObserver = undefined;
    }

    mutationObserver = new MutationObserver(function () {
      window.clearTimeout(initTimer);
      initTimer = window.setTimeout(function () {
        bindObserver(btn);
      }, 160);
    });
    mutationObserver.observe(productInfo, { childList: true, subtree: true });
  }

  function init() {
    var btn = portalButton();
    if (!btn) {
      setVisible(null, false);
      if (intersectionObserver) intersectionObserver.disconnect();
      if (mutationObserver) mutationObserver.disconnect();
      return;
    }

    if (!btn.dataset.bound) {
      btn.dataset.bound = 'true';
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        var target = findScrollTarget(btn);
        if (!target) return;
        target.style.scrollMarginTop = '8rem';
        var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'start',
        });
      });
    }

    bindObserver(btn);
    observeProductInfo(btn);
  }

  function start() {
    init();
    window.setTimeout(init, 400);
    window.setTimeout(init, 1600);

    if (!mediaQuery) {
      mediaQuery = window.matchMedia(DESKTOP_MQ);
      var onChange = function () {
        init();
      };
      if (mediaQuery.addEventListener) {
        mediaQuery.addEventListener('change', onChange);
      } else if (mediaQuery.addListener) {
        mediaQuery.addListener(onChange);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('product-info:loaded', function () {
    window.setTimeout(init, 50);
  });
})();
